import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StorageService } from '@core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'lib-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrl: './cookie-policy.component.scss',
  imports: [CommonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookiePolicyComponent {
  private storageService = inject(StorageService);
  private isCloseIconClicked = signal(false);
  hidden = computed(() => this.storageService.isCookiePolicyClosed || this.isCloseIconClicked());

  onClose(): void {
    this.storageService.isCookiePolicyClosed = true;
    this.isCloseIconClicked.set(true);
  }
}
